import * as React from 'react';
import styled from 'styled-components';

import { AquaTheme as T } from '../AquaTheme';
import { GlassPane, GlassPaneCaption } from '../GlassPane';
import { Number } from '../../formatters/Number';
import { Latitude, Longitude } from '../../formatters/GIS';
import { ILngLat, useMousePosition } from '../../util/MousePosition';

interface IProps {
  /** @ignore */
  className?: string;
  /** Placed marker, if any. Otherwise the panel follows the mouse. */
  marker: ILngLat | null;
}

/**
 * Mouse (or marker) coordinates on a GlassPane, in decimal degrees and DMS.
 */
const AquaCoordinatesBase = (props: IProps) => {
  const mouse = useMousePosition();
  const { lng, lat } = props.marker ?? mouse;
  return (
    <GlassPane bordered padded className={props.className}>
      <GlassPaneCaption>{props.marker ? "Marker" : "Cursor"}</GlassPaneCaption>
      <Grid>
        <Label>Lng</Label>
        <Value>{lng ? <Number value={lng} decimals={3}/> : '–'}</Value>
        <Dms>{lng ? <Longitude value={lng}/> : '–'}</Dms>
        <Label>Lat</Label>
        <Value>{lat ? <Number value={lat} decimals={3}/> : '–'}</Value>
        <Dms>{lat ? <Latitude value={lat}/> : '–'}</Dms>
      </Grid>
    </GlassPane>
  );
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 8px;
  margin-top: 6px;
`

const Label = styled.div`
  font: ${T.font.labelSmall};
  line-height: 20px;
  color: ${T.colors.primary[2]};
`

const Value = styled.div`
  font: ${T.font.dataSmall};
  text-align: right;
`

const Dms = styled.div`
  grid-column: 1 / span 2;
  font: ${T.font.bodySmall};
  text-align: right;
  color: ${T.colors.neutral[30]};
  margin-bottom: 4px;
`

const AquaCoordinates = styled(AquaCoordinatesBase)`
  width: 170px;
  user-select: none;
  pointer-events: none;
`

export { AquaCoordinates }
